import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import { Grid, Typography, Box, Button, Paper, Alert } from '@mui/material';
import SEO from './seo/seo';
import axios from 'axios';
import MaleIcon from '@mui/icons-material/Male';
import FemaleIcon from '@mui/icons-material/Female'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ShareMenu from './common/ShareButton';
import { backend } from '../statics/system_variables'
import { build_breed_str } from './content/card';
import default403 from '../resources/403.png';

export default function AnimalPage() {
    const navigate = useNavigate()
    const location = useLocation();
    const animal_id = decodeURI(location.pathname.split('/')[2])
    const [animal, setAnimal] = useState(null)

    useEffect(() => {
        const api_link = backend + '/dog?dog_id=' + animal_id
        axios.get(api_link)
            .then(({ data }) => {
                setAnimal(data)
            })
            .catch(() => {
                // Keep state as null in case of error
            })
    }, [animal_id])

    useEffect(() => {
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
    }, []);

    if (animal === null) {
        return null
    }

    const [breeds_element, breeds_str] = build_breed_str(animal)

    // Revert to original logic for AnimalPage: split and pass directly
    const picturesToDisplay = animal.picture_url ? animal.picture_url.split(',') : [];

    // Handler for image errors (fallback to default403)
    const handleImgError = (e) => {
        e.target.src = default403;
    };

    return (
        <>
            <SEO
                title={animal.name + " adoptieren - " + breeds_str}
                description={animal.description ? animal.description : ('Das hier ist ' + animal.name + '. Bist du bereit, ' + animal.name + ' ein neues zu Hause zu geben? Lernen ihn jetzt kennen!')}
                type='website'
                image = {animal.picture_url ? animal.picture_url.split(',')[0] : default403}
                />
            <Grid container mb={20} sx={{ p: { xs: 0, xl: 0 } }}>
                <Grid item xs={0} xl={3} />
                <Grid item xs={12} xl={6} mb={500} mt={0} >
                    <Paper sx={{ p: 3 }} elevation={10}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Button startIcon={<ArrowBackIosIcon />} onClick={() => { navigate(-1) }} >
                                Zurück
                            </Button>
                            <ShareMenu link={window.location.href} />
                        </Box>
                        <Alert variant='outlined' icon={false} severity='primary' sx={{ textAlign: 'center', justifyContent: 'center' }} component='h1'>{breeds_str} {animal.name} sucht ein neues zu Hause</Alert>
                        <AnimalHeader animal={animal} breeds_element={breeds_element} />
                        {/* Image gallery: horizontal scrollable row */}
                        <Box sx={{ width: '100%', mb: 3, overflowX: 'auto', display: 'flex', flexDirection: 'row', gap: 2, py: 1 }}>
                            {picturesToDisplay.map((pic, index) => (
                                <Box key={pic} sx={{ flex: '0 0 auto' }}>
                                    <img
                                        src={pic && !pic.includes('#403') ? pic : default403}
                                        alt={breeds_str + ' ' + (index + 1)}
                                        loading="lazy"
                                        width="auto"
                                        height="220"
                                        onError={handleImgError}
                                        style={{ height: 220, width: 'auto', borderRadius: 8, display: 'block' }}
                                    />
                                </Box>
                            ))}
                        </Box>
                        <Box mt={4} mb={5}>
                            <Typography variant="h4" gutterBottom>Über {animal.name}</Typography>
                            <Typography paragraph>
                                {animal.description}
                            </Typography>
                            <Typography variant="h5" gutterBottom>Steckbrief</Typography>
                            <ul style={{ marginTop: 0, marginBottom: 16, paddingLeft: 20 }}>
                                <li><strong>Geburtsdatum:</strong> {animal.birthday}</li>
                                <li><strong>Geschlecht:</strong> {animal.gender === 'm' ? 'Rüde' : animal.gender === 'f' ? 'Hündin' : 'Unbekannt'}</li>
                                <li><strong>Rasse:</strong> {breeds_str}</li>
                                <li><strong>Mischling:</strong> {animal.mixture ? 'Ja' : 'Nein'}</li>
                                {/*<li><strong>Zuletzt gesehen:</strong> {animal.last_seen}</li>*/}
                                <li><strong>Tierheim:</strong> {animal.shelter?.name}</li>
                                {/*<li><strong>Adresse des Tierheims:</strong> {animal.shelter?.adresse}</li>*/}
                                <li><strong>Bundesland:</strong> {animal.shelter?.state}</li>
                            </ul>
                        </Box>
                        <Button fullWidth={true} variant='contained' color='primary' href={animal.dog_link} target='_blank' rel='norefferer' title={'zur Seite von ' + animal.name} size='large'>
                            Zur Seite von {animal.name} im {animal.shelter.name}
                        </Button>
                    </Paper>
                </Grid>
                <Grid item xs={0} xl={3} />
            </Grid>
        </>)
}

function AnimalHeader(props) {

    return (<Box>
        <Typography variant='h3' component='h2'>
            {props.animal.name}
            {props.animal.gender === 'm' ? <MaleIcon fontSize='0.8em' sx={{ marginLeft: '0.1em' }} viewBox="0 -4 24 24" /> : null}
            {props.animal.gender === 'f' ? <FemaleIcon fontSize='0.8em' sx={{ marginLeft: '0.1em' }} viewBox="0 -4 24 24" /> : null}
        </Typography>
        <Typography variant='h5' color='text.secondary' component='h3' mb={1}>
            {props.breeds_element}
        </Typography>
    </Box>
    )
}



